import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["id", "language", "name", "description"],
  _excluded2 = ["lesson"];
/* eslint-disable hubspot-dev/prefer-hubspot-url-utils */
import { eu1 } from 'hubspot-url-utils/hublets';
import { useEffect, useState } from 'react';
import { readUnhandledEnumCase } from 'rpc-client-utils';
import { chirpEnumToString } from 'academy-common-lib/utils/chirp';
import { reportErrorToLogFetch } from 'academy-common-lib/utils/errorUtils';
import { useDataFetchingClient } from 'academy-common-lib/utils/DataFetchingClient';
import LinkContent from '../components/LinkContent';
import UsageTracker from '../utils/UsageTracker';
import { updateContentProgress } from '../features/userProgress';
import { Metrics } from '../Metrics';
import { jsx as _jsx } from "react/jsx-runtime";
const LinkContentContainer = _ref => {
  var _targetUrl2;
  let {
      track,
      lesson: {
        id: lessonId,
        name: lessonName,
        visibility: lessonVisibility
      },
      content: {
        id: contentId,
        language: contentLanguage,
        name,
        description
      },
      onFinish
    } = _ref,
    restContent = _objectWithoutPropertiesLoose(_ref.content, _excluded);
  const [hasClicked, setHasClicked] = useState(false);
  const client = useDataFetchingClient();
  const linkType = 'linkType' in restContent && restContent.linkType ? readUnhandledEnumCase(restContent.linkType) : undefined;
  let targetUrl = 'targetUrl' in restContent && restContent.targetUrl ? restContent.targetUrl : undefined;
  const ctaCopy = 'ctaCopy' in restContent && restContent.ctaCopy ? restContent.ctaCopy : undefined;
  useEffect(() => {
    setHasClicked(false);
  }, [contentId]);
  const handleRead = () => {
    setHasClicked(true);
    UsageTracker.trackStandalone('Content Interaction', {
      action: 'read-link',
      contentId,
      contentLanguage,
      contentType: 'link',
      trackId: track === null || track === void 0 ? void 0 : track.id,
      lessonId,
      lessonName,
      trackName: track === null || track === void 0 ? void 0 : track.name,
      linkType,
      visibility: chirpEnumToString(lessonVisibility)
    });
    updateContentProgress({
      contentId,
      trackId: track === null || track === void 0 ? void 0 : track.id,
      lessonId,
      language: contentLanguage
    }, client).then(() => {
      Metrics.counter('link-content-mutation', {
        action: 'link-read-progress-update'
      }).increment();
    }).catch(error => {
      Metrics.counter('link-mutation-call-error', {
        action: 'link-read-progress-update-error'
      }).increment();
      reportErrorToLogFetch({
        loggingTitle: 'Link Read Progress Update Error',
        action: 'link-read-progress-update-error',
        error,
        additionalData: {
          contentId,
          lessonId,
          trackId: track === null || track === void 0 ? void 0 : track.id
        }
      });
    });
  };
  const handleSkip = () => {
    UsageTracker.trackStandalone('Content Interaction', {
      action: 'skip-link',
      contentId,
      contentLanguage,
      contentType: 'link',
      trackId: track === null || track === void 0 ? void 0 : track.id,
      lessonId,
      lessonName,
      trackName: track === null || track === void 0 ? void 0 : track.name,
      linkType,
      visibility: chirpEnumToString(lessonVisibility)
    });
    updateContentProgress({
      contentId,
      trackId: track === null || track === void 0 ? void 0 : track.id,
      lessonId,
      language: contentLanguage
    }, client).then(() => {
      Metrics.counter('link-content-mutation', {
        action: 'link-progress-skipped'
      }).increment();
    }).catch(error => {
      Metrics.counter('link-mutation-call-error', {
        action: 'link-progress-skipped-error'
      }).increment();
      reportErrorToLogFetch({
        loggingTitle: 'Link Progress Skipped Error',
        action: 'link-progress-skipped-error',
        error,
        additionalData: {
          contentId,
          lessonId,
          trackId: track === null || track === void 0 ? void 0 : track.id
        }
      });
    });
    onFinish === null || onFinish === void 0 || onFinish();
  };
  if ( /* eslint-disable-next-line hubspot-dev/no-hublet-comparison, hubspot-dev/no-hublet-references */
  window.location.hostname.includes(eu1) && linkType !== 'HUBSPOT_COMMUNITY') {
    var _targetUrl;
    targetUrl = (_targetUrl = targetUrl) === null || _targetUrl === void 0 ? void 0 : _targetUrl.replaceAll('app.hubspot.com', 'app-eu1.hubspot.com');
  }
  return /*#__PURE__*/_jsx(LinkContent, {
    contentType: linkType,
    ctaCopy: ctaCopy !== null && ctaCopy !== void 0 ? ctaCopy : undefined,
    description: description,
    hasClicked: hasClicked,
    href: (_targetUrl2 = targetUrl) !== null && _targetUrl2 !== void 0 ? _targetUrl2 : '',
    name: name,
    onFinish: onFinish,
    onRead: handleRead,
    onSkip: handleSkip
  });
};
const LinkContentContainerContent = _ref2 => {
  let {
      lesson
    } = _ref2,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return lesson ? /*#__PURE__*/_jsx(LinkContentContainer, Object.assign({
    lesson: lesson
  }, props)) : null;
};
export default LinkContentContainerContent;